import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

export interface TypeBlogSectionFields {
    internalName: EntryFieldTypes.Symbol;
    visibility?: EntryFieldTypes.Symbol<'loggedIn' | 'loggedOut'>;
    type: EntryFieldTypes.Symbol<'highlight' | 'image' | 'note' | 'quote' | 'text' | 'video' | 'youtube-embed'>;
    title?: EntryFieldTypes.Symbol;
    slug?: EntryFieldTypes.Symbol;
    text?: EntryFieldTypes.RichText;
    images?: EntryFieldTypes.Array<EntryFieldTypes.AssetLink>;
    video?: EntryFieldTypes.AssetLink;
    videoPoster?: EntryFieldTypes.AssetLink;
    captions?: EntryFieldTypes.AssetLink;
    author?: EntryFieldTypes.Symbol;
    youtubeEmbedUrl?: EntryFieldTypes.Symbol;
}

export type TypeBlogSectionSkeleton = EntrySkeletonType<TypeBlogSectionFields, 'blogSection'>;
export type TypeBlogSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlogSectionSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlogSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlogSection<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blogSection';
}
